export const HomeIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="#000000" fillRule="evenodd">
      <g id="home-breadcrumnbs">
        <path
          d="M15,14.64375 C15,14.83975 14.825,14.99975 14.61,14.99975 L6.389,14.99975 C6.178,14.99975 6,14.83675 6,14.64375 L6,8.78775 L10.498,5.14375 L14.999,8.78975 L15,14.64375 Z M18,9.93275 L10.813,4.11175 C10.629,3.96275 10.367,3.96275 10.183,4.11175 L3,9.92975 L3.63,10.70675 L5,9.59775 L5,14.64375 C5,15.39175 5.623,15.99975 6.389,15.99975 L14.61,15.99975 C15.376,15.99975 16,15.39175 16,14.64375 L15.999,9.59975 L17.37,10.70975 L18,9.93275 Z"
          id="Fill-1"
        ></path>
      </g>
    </g>
  </svg>
);
